import React from 'react';
import { BUDGET_COLORS } from '@/types/budgetColors';

interface ColorPickerProps {
  value?: string;
  onChange?: (color: string) => void;
  className?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ value = '', onChange, className = '' }) => {
  return (
    <div className={`flex flex-wrap items-center gap-x-3 md:gap-x-4 gap-y-2 ${className}`}>
      {BUDGET_COLORS.map((color) => (
        <button
          type="button"
          className={`border-2 border-[#E9ECEF] rounded-full ${value === color.value ? '!border-primary' : ''}`}
          key={color.name}
          style={{ backgroundColor: color.value }}
          onClick={() => onChange?.(color.value)}
        >
          <span className="block w-7 h-7 rounded-full border-2 border-[#fff]"></span>
        </button>
      ))}
    </div>
  );
};

export default ColorPicker;
